module.exports = __webpack_public_path__ + "media/images/emoticons/golf-3fa3cf29a0ab8680e402dafeec244df6.gif";